import { render, staticRenderFns } from "./edit-transactions.vue?vue&type=template&id=60dd6307&scoped=true"
import script from "./edit-transactions.vue?vue&type=script&lang=js"
export * from "./edit-transactions.vue?vue&type=script&lang=js"
import style0 from "./edit-transactions.vue?vue&type=style&index=0&id=60dd6307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd6307",
  null
  
)

export default component.exports